// // import React, { useState, useEffect } from 'react';
// // import { ThumbsUp, ThumbsDown, Loader2 } from 'lucide-react';
// // import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
// // import {
// //     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer,
// //     LineChart, Line, PieChart, Pie, Cell, Legend
// // } from 'recharts';

// // const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://smart-info-hub-api.mpix.my.id';
// // const API = `${API_BASE_URL}/api`;

// // const AnalyticsDashboard = () => {
// //     const [data, setData] = useState(null);
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState(null);

// //     useEffect(() => {
// //         const fetchAnalytics = async () => {
// //             try {
// //                 const token = localStorage.getItem('auth_token');
// //                 const response = await fetch(`${API}/admin/analytics/search`, {
// //                     headers: { Authorization: `Bearer ${token}` }
// //                 });

// //                 if (!response.ok) throw new Error('Gagal memuat data');

// //                 const result = await response.json();
// //                 setData(result);
// //             } catch (err) {
// //                 console.error("Failed to load analytics", err);
// //                 setError("Gagal memuat data analitik.");
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         fetchAnalytics();
// //     }, []);

// //     if (loading) return <div className="flex justify-center p-12"><Loader2 className="w-8 h-8 animate-spin text-blue-500" /></div>;
// //     if (error) return <div className="p-8 text-center text-red-500">{error}</div>;
// //     if (!data) return <div className="p-8 text-center text-gray-500">Tidak ada data.</div>;

// //     const pieData = [
// //         { name: 'Puas', value: data.feedback_stats?.satisfied || 0, color: '#22c55e' },
// //         { name: 'Tidak Puas', value: data.feedback_stats?.dissatisfied || 0, color: '#ef4444' },
// //     ];

// //     return (
// //         <div className="space-y-6 animate-in fade-in duration-500">
// //             {/* Kartu Ringkasan */}
// //             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
// //                 <Card>
// //                     <CardHeader className="pb-2">
// //                         <CardTitle className="text-sm font-medium text-gray-500">Pencarian Hari Ini</CardTitle>
// //                     </CardHeader>
// //                     <CardContent>
// //                         <div className="text-2xl font-bold">{data.today_searches}</div>
// //                     </CardContent>
// //                 </Card>
// //                 <Card>
// //                     <CardHeader className="pb-2">
// //                         <CardTitle className="text-sm font-medium text-gray-500">Total Keyword Unik</CardTitle>
// //                     </CardHeader>
// //                     <CardContent>
// //                         <div className="text-2xl font-bold">{data.total_unique_queries}</div>
// //                     </CardContent>
// //                 </Card>
// //                 <Card>
// //                     <CardHeader className="pb-2">
// //                         <CardTitle className="text-sm font-medium text-gray-500">Total Ulasan</CardTitle>
// //                     </CardHeader>
// //                     <CardContent>
// //                         <div className="text-2xl font-bold">{data.feedback_stats?.total || 0}</div>
// //                     </CardContent>
// //                 </Card>
// //             </div>

// //             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
// //                 {/* Grafik Tren Harian */}
// //                 <Card className="col-span-1 lg:col-span-2">
// //                     <CardHeader>
// //                         <CardTitle>Tren Pencarian (30 Hari Terakhir)</CardTitle>
// //                     </CardHeader>
// //                     <CardContent className="h-[300px]">
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <LineChart data={data.daily_stats}>
// //                                 <CartesianGrid strokeDasharray="3 3" vertical={false} />
// //                                 <XAxis dataKey="date" tickFormatter={(str) => new Date(str).getDate()} />
// //                                 <YAxis allowDecimals={false} />
// //                                 <RechartsTooltip
// //                                     labelFormatter={(label) => new Date(label).toLocaleDateString('id-ID', { day: 'numeric', month: 'long' })}
// //                                 />
// //                                 <Line type="monotone" dataKey="count" stroke="#2563eb" strokeWidth={2} dot={false} activeDot={{ r: 6 }} />
// //                             </LineChart>
// //                         </ResponsiveContainer>
// //                     </CardContent>
// //                 </Card>

// //                 {/* Top Keywords */}
// //                 <Card>
// //                     <CardHeader>
// //                         <CardTitle>Top Keyword Pencarian</CardTitle>
// //                     </CardHeader>
// //                     <CardContent className="h-[350px]">
// //                         <ResponsiveContainer width="100%" height="100%">
// //                             <BarChart layout="vertical" data={data.top_searches.slice(0, 10)}>
// //                                 <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
// //                                 <XAxis type="number" hide />
// //                                 <YAxis type="category" dataKey="query" width={120} tick={{ fontSize: 12 }} />
// //                                 <RechartsTooltip />
// //                                 <Bar dataKey="count" fill="#3b82f6" radius={[0, 4, 4, 0]} barSize={20} />
// //                             </BarChart>
// //                         </ResponsiveContainer>
// //                     </CardContent>
// //                 </Card>

// //                 {/* Pie Chart Kepuasan */}
// //                 <Card>
// //                     <CardHeader>
// //                         <CardTitle>Kepuasan Pengguna</CardTitle>
// //                     </CardHeader>
// //                     <CardContent className="h-[350px] flex items-center justify-center">
// //                         {data.feedback_stats?.total > 0 ? (
// //                             <ResponsiveContainer width="100%" height="100%">
// //                                 <PieChart>
// //                                     <Pie
// //                                         data={pieData}
// //                                         cx="50%"
// //                                         cy="50%"
// //                                         innerRadius={60}
// //                                         outerRadius={100}
// //                                         paddingAngle={5}
// //                                         dataKey="value"
// //                                     >
// //                                         {pieData.map((entry, index) => (
// //                                             <Cell key={`cell-${index}`} fill={entry.color} />
// //                                         ))}
// //                                     </Pie>
// //                                     <RechartsTooltip />
// //                                     <Legend verticalAlign="bottom" height={36} />
// //                                 </PieChart>
// //                             </ResponsiveContainer>
// //                         ) : (
// //                             <p className="text-gray-400">Belum ada data ulasan</p>
// //                         )}
// //                     </CardContent>
// //                 </Card>
// //             </div>

// //             {/* Tabel Feedback Terbaru */}
// //             <Card>
// //                 <CardHeader>
// //                     <CardTitle>Ulasan Terbaru</CardTitle>
// //                 </CardHeader>
// //                 <CardContent>
// //                     <div className="space-y-4">
// //                         {data.recent_feedbacks.length > 0 ? (
// //                             data.recent_feedbacks.map((fb) => (
// //                                 <div key={fb.id} className="flex items-start gap-4 p-3 rounded-lg border bg-gray-50">
// //                                     <div className={`p-2 rounded-full ${fb.is_satisfied ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
// //                                         {fb.is_satisfied ? <ThumbsUp size={16} /> : <ThumbsDown size={16} />}
// //                                     </div>
// //                                     <div className="flex-1">
// //                                         <div className="flex justify-between items-start">
// //                                             <p className="font-medium text-sm text-gray-900">
// //                                                 Query: "{fb.query}"
// //                                             </p>
// //                                             <span className="text-xs text-gray-500">
// //                                                 {new Date(fb.created_at).toLocaleDateString('id-ID')}
// //                                             </span>
// //                                         </div>
// //                                         {fb.comment && (
// //                                             <p className="text-sm text-gray-600 mt-1">"{fb.comment}"</p>
// //                                         )}
// //                                     </div>
// //                                 </div>
// //                             ))
// //                         ) : (
// //                             <p className="text-gray-500 text-center py-4">Belum ada ulasan.</p>
// //                         )}
// //                     </div>
// //                 </CardContent>
// //             </Card>
// //         </div>
// //     );
// // };

// // export default AnalyticsDashboard;

// import React, { useState, useEffect } from 'react';
// import { ThumbsUp, ThumbsDown, Loader2, Sparkles, Search as SearchIcon } from 'lucide-react';
// import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./ui/card";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer,
//     LineChart, Line, PieChart, Pie, Cell, Legend
// } from 'recharts';

// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://smart-info-hub-api.mpix.my.id';
// const API = `${API_BASE_URL}/api`;

// const AnalyticsDashboard = () => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchAnalytics = async () => {
//             try {
//                 const token = localStorage.getItem('auth_token');
//                 const response = await fetch(`${API}/admin/analytics/search`, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });

//                 if (!response.ok) throw new Error('Gagal memuat data');

//                 const result = await response.json();
//                 setData(result);
//             } catch (err) {
//                 console.error("Failed to load analytics", err);
//                 setError("Gagal memuat data analitik.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAnalytics();
//     }, []);

//     if (loading) return <div className="flex justify-center p-12"><Loader2 className="w-8 h-8 animate-spin text-blue-500" /></div>;
//     if (error) return <div className="p-8 text-center text-red-500">{error}</div>;
//     if (!data) return <div className="p-8 text-center text-gray-500">Tidak ada data.</div>;

//     const pieData = [
//         { name: 'Puas', value: data.feedback_stats?.satisfied || 0, color: '#22c55e' },
//         { name: 'Tidak Puas', value: data.feedback_stats?.dissatisfied || 0, color: '#ef4444' },
//     ];

//     return (
//         <div className="space-y-6 animate-in fade-in duration-500">
//             {/* Kartu Ringkasan */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                 <Card>
//                     <CardHeader className="pb-2">
//                         <CardTitle className="text-sm font-medium text-gray-500">Pencarian Hari Ini</CardTitle>
//                     </CardHeader>
//                     <CardContent>
//                         <div className="text-2xl font-bold">{data.today_searches}</div>
//                     </CardContent>
//                 </Card>
//                 <Card>
//                     <CardHeader className="pb-2">
//                         <CardTitle className="text-sm font-medium text-gray-500">Total Keyword Unik</CardTitle>
//                     </CardHeader>
//                     <CardContent>
//                         <div className="text-2xl font-bold">{data.total_unique_queries}</div>
//                     </CardContent>
//                 </Card>
//                 <Card>
//                     <CardHeader className="pb-2">
//                         <CardTitle className="text-sm font-medium text-gray-500">Total Ulasan</CardTitle>
//                     </CardHeader>
//                     <CardContent>
//                         <div className="text-2xl font-bold">{data.feedback_stats?.total || 0}</div>
//                     </CardContent>
//                 </Card>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//                 {/* Grafik Tren Harian */}
//                 <Card className="col-span-1 lg:col-span-2">
//                     <CardHeader>
//                         <CardTitle>Tren Pencarian (30 Hari Terakhir)</CardTitle>
//                     </CardHeader>
//                     <CardContent className="h-[300px]">
//                         <ResponsiveContainer width="100%" height="100%">
//                             <LineChart data={data.daily_stats}>
//                                 <CartesianGrid strokeDasharray="3 3" vertical={false} />
//                                 <XAxis dataKey="date" tickFormatter={(str) => new Date(str).getDate()} />
//                                 <YAxis allowDecimals={false} />
//                                 <RechartsTooltip
//                                     labelFormatter={(label) => new Date(label).toLocaleDateString('id-ID', { day: 'numeric', month: 'long' })}
//                                 />
//                                 <Line type="monotone" dataKey="count" stroke="#2563eb" strokeWidth={2} dot={false} activeDot={{ r: 6 }} />
//                             </LineChart>
//                         </ResponsiveContainer>
//                     </CardContent>
//                 </Card>

//                 {/* Top Keywords / Topics Section */}
//                 <Card>
//                     <CardHeader>
//                         <CardTitle>Top Pencarian</CardTitle>
//                         <CardDescription>Apa yang paling sering dicari pengguna?</CardDescription>
//                     </CardHeader>
//                     <CardContent>
//                         <Tabs defaultValue="topics" className="w-full">
//                             <TabsList className="grid w-full grid-cols-2 mb-4">
//                                 <TabsTrigger value="topics" className="flex items-center gap-2">
//                                     <Sparkles className="w-4 h-4 text-purple-500" />
//                                     Topik (AI)
//                                 </TabsTrigger>
//                                 <TabsTrigger value="queries" className="flex items-center gap-2">
//                                     <SearchIcon className="w-4 h-4 text-blue-500" />
//                                     Query Asli
//                                 </TabsTrigger>
//                             </TabsList>

//                             <TabsContent value="topics" className="h-[300px]">
//                                 {data.top_topics && data.top_topics.length > 0 ? (
//                                     <ResponsiveContainer width="100%" height="100%">
//                                         <BarChart layout="vertical" data={data.top_topics}>
//                                             <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
//                                             <XAxis type="number" hide />
//                                             <YAxis type="category" dataKey="query" width={100} tick={{ fontSize: 12 }} />
//                                             <RechartsTooltip cursor={{ fill: 'transparent' }} />
//                                             <Bar dataKey="count" fill="#8b5cf6" radius={[0, 4, 4, 0]} barSize={20} name="Jumlah Pencarian" />
//                                         </BarChart>
//                                     </ResponsiveContainer>
//                                 ) : (
//                                     <div className="flex h-full items-center justify-center text-gray-400 text-sm flex-col gap-2">
//                                         <Sparkles className="w-8 h-8 opacity-20" />
//                                         <p>Belum cukup data topik AI.</p>
//                                         <p className="text-xs">Data akan muncul seiring pengguna melakukan pencarian baru.</p>
//                                     </div>
//                                 )}
//                             </TabsContent>

//                             <TabsContent value="queries" className="h-[300px]">
//                                 <ResponsiveContainer width="100%" height="100%">
//                                     <BarChart layout="vertical" data={data.top_searches.slice(0, 10)}>
//                                         <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
//                                         <XAxis type="number" hide />
//                                         <YAxis type="category" dataKey="query" width={100} tick={{ fontSize: 12 }} />
//                                         <RechartsTooltip cursor={{ fill: 'transparent' }} />
//                                         <Bar dataKey="count" fill="#3b82f6" radius={[0, 4, 4, 0]} barSize={20} name="Jumlah Pencarian" />
//                                     </BarChart>
//                                 </ResponsiveContainer>
//                             </TabsContent>
//                         </Tabs>
//                     </CardContent>
//                 </Card>

//                 {/* Pie Chart Kepuasan */}
//                 <Card>
//                     <CardHeader>
//                         <CardTitle>Kepuasan Pengguna</CardTitle>
//                         <CardDescription>Berdasarkan ulasan user</CardDescription>
//                     </CardHeader>
//                     <CardContent className="h-[350px] flex items-center justify-center">
//                         {data.feedback_stats?.total > 0 ? (
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <PieChart>
//                                     <Pie
//                                         data={pieData}
//                                         cx="50%"
//                                         cy="50%"
//                                         innerRadius={60}
//                                         outerRadius={100}
//                                         paddingAngle={5}
//                                         dataKey="value"
//                                     >
//                                         {pieData.map((entry, index) => (
//                                             <Cell key={`cell-${index}`} fill={entry.color} />
//                                         ))}
//                                     </Pie>
//                                     <RechartsTooltip />
//                                     <Legend verticalAlign="bottom" height={36} />
//                                 </PieChart>
//                             </ResponsiveContainer>
//                         ) : (
//                             <div className="flex h-full items-center justify-center text-gray-400 text-sm">
//                                 Belum ada data ulasan
//                             </div>
//                         )}
//                     </CardContent>
//                 </Card>
//             </div>

//             {/* Tabel Feedback Terbaru */}
//             <Card>
//                 <CardHeader>
//                     <CardTitle>Ulasan Terbaru</CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                     <div className="space-y-4">
//                         {data.recent_feedbacks.length > 0 ? (
//                             data.recent_feedbacks.map((fb) => (
//                                 <div key={fb.id} className="flex items-start gap-4 p-3 rounded-lg border bg-gray-50">
//                                     <div className={`p-2 rounded-full ${fb.is_satisfied ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
//                                         {fb.is_satisfied ? <ThumbsUp size={16} /> : <ThumbsDown size={16} />}
//                                     </div>
//                                     <div className="flex-1">
//                                         <div className="flex justify-between items-start">
//                                             <p className="font-medium text-sm text-gray-900">
//                                                 Query: "{fb.query}"
//                                             </p>
//                                             <span className="text-xs text-gray-500">
//                                                 {new Date(fb.created_at).toLocaleDateString('id-ID')}
//                                             </span>
//                                         </div>
//                                         {fb.comment && (
//                                             <p className="text-sm text-gray-600 mt-1 italic">"{fb.comment}"</p>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))
//                         ) : (
//                             <p className="text-gray-500 text-center py-4">Belum ada ulasan.</p>
//                         )}
//                     </div>
//                 </CardContent>
//             </Card>
//         </div>
//     );
// };

// export default AnalyticsDashboard;

import React, { useState, useEffect, useMemo } from 'react';
import { ThumbsUp, ThumbsDown, Loader2, Sparkles, Search as SearchIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer,
    LineChart, Line, PieChart, Pie, Cell, Legend
} from 'recharts';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://smart-info-hub-api.mpix.my.id';
const API = `${API_BASE_URL}/api`;

// Helper untuk menggabungkan data yang sama (Case Insensitive)
// Contoh: "Jualan Pulsa", "jualan pulsa", "Jualan pulsa" -> Digabung jadi satu entri dengan total count
const consolidateData = (dataArray) => {
    if (!Array.isArray(dataArray)) return [];

    const map = new Map();

    dataArray.forEach(item => {
        if (!item.query) return;
        // Normalisasi key menjadi huruf kecil semua untuk pengecekan
        const normalizedKey = item.query.toLowerCase().trim();

        if (map.has(normalizedKey)) {
            const existing = map.get(normalizedKey);
            existing.count += item.count;

            // Opsional: Jika label yang baru ditemukan terlihat lebih "bagus" (misal Title Case), gunakan itu
            // Contoh: update dari "jualan pulsa" ke "Jualan Pulsa"
            if (item.query[0] === item.query[0].toUpperCase() && existing.query[0] !== existing.query[0].toUpperCase()) {
                existing.query = item.query;
            }
        } else {
            // Clone item agar tidak memutasi array asli
            map.set(normalizedKey, { ...item });
        }
    });

    // Kembalikan ke bentuk array dan urutkan dari count terbanyak
    return Array.from(map.values()).sort((a, b) => b.count - a.count);
};

const AnalyticsDashboard = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAnalytics = async () => {
            try {
                const token = localStorage.getItem('auth_token');
                const response = await fetch(`${API}/admin/analytics/search`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (!response.ok) throw new Error('Gagal memuat data');

                const result = await response.json();
                setData(result);
            } catch (err) {
                console.error("Failed to load analytics", err);
                setError("Gagal memuat data analitik.");
            } finally {
                setLoading(false);
            }
        };

        fetchAnalytics();
    }, []);

    // Proses data menggunakan useMemo agar tidak dihitung ulang setiap render
    const processedTopTopics = useMemo(() => {
        if (!data?.top_topics) return [];
        return consolidateData(data.top_topics).slice(0, 10);
    }, [data]);

    const processedTopSearches = useMemo(() => {
        if (!data?.top_searches) return [];
        return consolidateData(data.top_searches).slice(0, 10);
    }, [data]);

    if (loading) return <div className="flex justify-center p-12"><Loader2 className="w-8 h-8 animate-spin text-blue-500" /></div>;
    if (error) return <div className="p-8 text-center text-red-500">{error}</div>;
    if (!data) return <div className="p-8 text-center text-gray-500">Tidak ada data.</div>;

    const pieData = [
        { name: 'Puas', value: data.feedback_stats?.satisfied || 0, color: '#22c55e' },
        { name: 'Tidak Puas', value: data.feedback_stats?.dissatisfied || 0, color: '#ef4444' },
    ];

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            {/* Kartu Ringkasan */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium text-gray-500">Pencarian Hari Ini</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">{data.today_searches}</div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium text-gray-500">Total Keyword Unik</CardTitle>
                    </CardHeader>
                    <CardContent>
                        {/* Total unik dihitung dari data yang sudah digabungkan agar lebih akurat */}
                        <div className="text-2xl font-bold">{processedTopSearches.length}</div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium text-gray-500">Total Ulasan</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">{data.feedback_stats?.total || 0}</div>
                    </CardContent>
                </Card>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Grafik Tren Harian */}
                <Card className="col-span-1 lg:col-span-2">
                    <CardHeader>
                        <CardTitle>Tren Pencarian (30 Hari Terakhir)</CardTitle>
                    </CardHeader>
                    <CardContent className="h-[300px]">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={data.daily_stats}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="date" tickFormatter={(str) => new Date(str).getDate()} />
                                <YAxis allowDecimals={false} />
                                <RechartsTooltip
                                    labelFormatter={(label) => new Date(label).toLocaleDateString('id-ID', { day: 'numeric', month: 'long' })}
                                />
                                <Line type="monotone" dataKey="count" stroke="#2563eb" strokeWidth={2} dot={false} activeDot={{ r: 6 }} />
                            </LineChart>
                        </ResponsiveContainer>
                    </CardContent>
                </Card>

                {/* Top Keywords / Topics Section */}
                <Card>
                    <CardHeader>
                        <CardTitle>Top Pencarian</CardTitle>
                        <CardDescription>Apa yang paling sering dicari pengguna?</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <Tabs defaultValue="topics" className="w-full">
                            <TabsList className="grid w-full grid-cols-2 mb-4">
                                <TabsTrigger value="topics" className="flex items-center gap-2">
                                    <Sparkles className="w-4 h-4 text-purple-500" />
                                    Topik (AI)
                                </TabsTrigger>
                                <TabsTrigger value="queries" className="flex items-center gap-2">
                                    <SearchIcon className="w-4 h-4 text-blue-500" />
                                    Query Asli
                                </TabsTrigger>
                            </TabsList>

                            <TabsContent value="topics" className="h-[300px]">
                                {processedTopTopics.length > 0 ? (
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart layout="vertical" data={processedTopTopics}>
                                            <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
                                            <XAxis type="number" hide />
                                            <YAxis type="category" dataKey="query" width={100} tick={{ fontSize: 12 }} />
                                            <RechartsTooltip cursor={{ fill: 'transparent' }} />
                                            <Bar dataKey="count" fill="#8b5cf6" radius={[0, 4, 4, 0]} barSize={20} name="Jumlah Pencarian" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                ) : (
                                    <div className="flex h-full items-center justify-center text-gray-400 text-sm flex-col gap-2">
                                        <Sparkles className="w-8 h-8 opacity-20" />
                                        <p>Belum cukup data topik AI.</p>
                                        <p className="text-xs">Data akan muncul seiring pengguna melakukan pencarian baru.</p>
                                    </div>
                                )}
                            </TabsContent>

                            <TabsContent value="queries" className="h-[300px]">
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart layout="vertical" data={processedTopSearches}>
                                        <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
                                        <XAxis type="number" hide />
                                        <YAxis type="category" dataKey="query" width={100} tick={{ fontSize: 12 }} />
                                        <RechartsTooltip cursor={{ fill: 'transparent' }} />
                                        <Bar dataKey="count" fill="#3b82f6" radius={[0, 4, 4, 0]} barSize={20} name="Jumlah Pencarian" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </TabsContent>
                        </Tabs>
                    </CardContent>
                </Card>

                {/* Pie Chart Kepuasan */}
                <Card>
                    <CardHeader>
                        <CardTitle>Kepuasan Pengguna</CardTitle>
                        <CardDescription>Berdasarkan ulasan user</CardDescription>
                    </CardHeader>
                    <CardContent className="h-[350px] flex items-center justify-center">
                        {data.feedback_stats?.total > 0 ? (
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie
                                        data={pieData}
                                        cx="50%"
                                        cy="50%"
                                        innerRadius={60}
                                        outerRadius={100}
                                        paddingAngle={5}
                                        dataKey="value"
                                    >
                                        {pieData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    <RechartsTooltip />
                                    <Legend verticalAlign="bottom" height={36} />
                                </PieChart>
                            </ResponsiveContainer>
                        ) : (
                            <div className="flex h-full items-center justify-center text-gray-400 text-sm">
                                Belum ada data ulasan
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>

            {/* Tabel Feedback Terbaru */}
            <Card>
                <CardHeader>
                    <CardTitle>Ulasan Terbaru</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="space-y-4">
                        {data.recent_feedbacks.length > 0 ? (
                            data.recent_feedbacks.map((fb) => (
                                <div key={fb.id} className="flex items-start gap-4 p-3 rounded-lg border bg-gray-50">
                                    <div className={`p-2 rounded-full ${fb.is_satisfied ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                                        {fb.is_satisfied ? <ThumbsUp size={16} /> : <ThumbsDown size={16} />}
                                    </div>
                                    <div className="flex-1">
                                        <div className="flex justify-between items-start">
                                            <p className="font-medium text-sm text-gray-900">
                                                Query: "{fb.query}"
                                            </p>
                                            <span className="text-xs text-gray-500">
                                                {new Date(fb.created_at).toLocaleDateString('id-ID')}
                                            </span>
                                        </div>
                                        {fb.comment && (
                                            <p className="text-sm text-gray-600 mt-1 italic">"{fb.comment}"</p>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500 text-center py-4">Belum ada ulasan.</p>
                        )}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default AnalyticsDashboard;